 <div class="card">
          <div class="card-header">
            <h4 class="card-title">     {{ 'MENU.DASHBOARD.contact_us' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.messages_platform_title' | translate }}</p>
          </div>
        </div>

<div class="container" style="display: flex; justify-content: center;">
   <div class="contact-card mt-3">
        <div class="card-header2">
            <div class="avatar2">
               <img
          *ngIf="employee?.user?.image"
          [src]="employee.user.image"
          alt="User Image"
          class="rounded-circle"
          style="width:60px; height:60px; object-fit:cover;"
        />
        <i *ngIf="!employee?.user?.image" class="fas fa-user"></i>
      </div>
             <h1 class="name">{{ employee?.name }}</h1>
      <p class="title">{{ employee?.user?.type | titlecase }}</p>
        </div>
        
        <div class="card-body">
            <div class="contact-info">
                <div class="info-item">
                    <div class="icon">
                        <i class="fas fa-phone"></i>
                    </div>
                    <div class="info-content mx-1">
                        <div class="info-label">{{ 'MENU.DASHBOARD.phone' | translate }} </div>
                        <div class="info-value">{{ employee?.mobile }}</div>
                    </div>
                </div>
                
                <div class="info-item">
                    <div class="icon">
                        <i class="fas fa-envelope"></i>
                    </div>
                    <div class="info-content  mx-1">
                        <div class="info-label">{{ 'MENU.DASHBOARD.email' | translate }} </div>
                        <div class="info-value">{{ employee?.email }}</div>
                    </div>
                </div>
            </div>

             <!-- <div class="info-item">
                    <div class="icon">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="info-content">
                        <div class="info-label">{{ 'MENU.DASHBOARD.status' | translate }}</div>
                        <div class="status-content my-1">
                            <span class="status-badge status-active" style="font-size: 12px; padding: 4px 10px;">
                                <i class="fas fa-check"></i>  {{ 'MENU.DASHBOARD.replied' | translate }}
                            </span>
                             <span class="status-badge status-pending" style="font-size: 12px; padding: 4px 10px;">
                                <i class="fas fa-circle"></i>  {{ 'MENU.DASHBOARD.under_review' | translate }}
                            </span>
                             <span class="status-badge status-inactive" style="font-size: 12px; padding: 4px 10px;">
                                <i class="fas fa-times"></i>  {{ 'MENU.DASHBOARD.not_replied' | translate }}   
                            </span>
                        </div>
                    </div>
                </div> -->
           
                  <div class="info-item">
        <div class="icon"><i class="fas fa-info-circle"></i></div>
        <div class="info-content  mx-1">
          <div class="info-label">{{ 'MENU.DASHBOARD.status' | translate }}</div>
          <div class="status-content ">
            <span *ngIf="employee.status === 'replied'" class="status-badge status-active">
              <i class="fas fa-check"></i> {{ 'MENU.DASHBOARD.replied' | translate }}
            </span>

            <span *ngIf="employee.status === 'pending'" class="status-badge status-pending">
              <i class="fas fa-circle"></i> {{ 'MENU.DASHBOARD.under_review' | translate }}
            </span>

            <span *ngIf="employee.status === 'closed'" class="status-badge status-inactive">
              <i class="fas fa-times"></i> {{ 'MENU.DASHBOARD.not_replied' | translate }}
            </span>
          </div>
        </div>
      </div>

            
            <div class="message-section">
                 <div class="info-content my-1">
                        <div class="message-label">  {{ 'MENU.DASHBOARD.message_title' | translate }} </div>
                        <div class="message-content"> {{ employee?.title }} </div>
                    </div>
                <span class="message-label">{{ 'MENU.DASHBOARD.message_content' | translate }}</span>
                <div class="message-content">
                      {{ employee?.message }}
                </div>
            </div>

             <div class="actions">
                <button class="btn" style="background-color:#cca44c ; color: #fff;" (click)="openStatusModal()">
                    <i class="fas fa-edit"></i>   {{ 'MENU.DASHBOARD.update_status' | translate }}  
                </button>
        </div>



    </div>

   </div>
</div>
  


<!-- Status Update Modal -->
<div class="status-modal-backdrop" *ngIf="showStatusModal">
  <div class="status-modal">
    <h4 class="status-modal-title">
      <i class="fas fa-edit me-2 text-gold"></i>
      {{ 'MENU.DASHBOARD.choose_status' | translate }}
    </h4>

    <div class="status-modal-body">
      <!-- <label for="statusSelect" class="form-label">
        {{ 'MENU.DASHBOARD.select_status' | translate }}
      </label> -->
      <select
        id="statusSelect"
        class="form-control status-select"
        [(ngModel)]="selectedStatus"
      >
        <option value="pending">{{ 'MENU.DASHBOARD.under_review' | translate }}</option>
        <option value="replied">{{ 'MENU.DASHBOARD.replied' | translate }}</option>
        <option value="closed">{{ 'MENU.DASHBOARD.not_replied' | translate }}</option>
      </select>
    </div>

    <div class="status-modal-footer">
      <button class="btn btn-cancel" (click)="closeStatusModal()">
        {{ 'MENU.DASHBOARD.cancel' | translate }}
      </button>
      <button class="btn btn-save" (click)="updateStatus()">
        {{ 'MENU.DASHBOARD.save' | translate }}
      </button>
    </div>
  </div>
</div>

